import React, { useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import PopupOverlay from 'components_v2/common/PopupOverlay/PopupOverlay';
import ImageV2 from 'components_v2/common/ImageV2';
import Video from 'components/Video/Video';
import { IMAGE_URL } from '../../../constants';
import s from './StoryCardPopup.scss';

const StoryCardPopup = ({
  show,
  bannerPopup,
  popupRef,
  onClose,
  onOverlayClose,
  imagePlaceHolderSrc,
  updateplayerConfig,
  white,
  isMobile,
}) => {
  const modalRef = useRef(null);

  const setModalRef = useCallback(node => {
    modalRef.current = node;
  }, []);

  const onError = e => {
    const fallbackSrc = imagePlaceHolderSrc || `${IMAGE_URL}123379562.cms`;
    if (e.target.src === fallbackSrc) return;
    if (typeof window !== 'undefined') {
      fetch(
        `https://timesofindia.indiatimes.com/invalidphoto.cms?v=19&url=${
          window.location.href
        }&src=${encodeURIComponent(e.target.src)}`,
      );
    }
    e.target.onerror = null;
    e.target.src = fallbackSrc;
  };

  const handleCloseClick = useCallback(
    () => {
      if (
        popupRef &&
        popupRef.current &&
        typeof popupRef.current.close === 'function'
      ) {
        popupRef.current.close();
      } else {
        (onOverlayClose || onClose)();
      }
    },
    [popupRef, onOverlayClose, onClose],
  );

  if (!show || !bannerPopup) return null;

  const isVideo = !!bannerPopup.slikeId;
  const heading = bannerPopup.hl || bannerPopup.title;
  const synopsis = bannerPopup.syn || bannerPopup.des || bannerPopup.cap;

  return (
    <PopupOverlay
      ref={popupRef}
      position={isMobile ? 'bottom' : 'center'}
      closeCallback={onOverlayClose || onClose}
      show={show}
      blackOverlayEnabled
      fixWidth={isVideo}
      enableClose={false}
      noGap
      maxHeight={!isMobile}
      noBorderRadius
    >
      <div
        className={`${s.storyCardPopup} ${white ? s.whiteTheme : s.darkTheme}`}
        ref={setModalRef}
      >
        <button
          type="button"
          className={s.popupClose}
          onClick={handleCloseClick}
          aria-label="Close"
        />

        <div className={s.popupScrollArea}>
          {/* Media: video or image */}
          <div className={s.popupMedia}>
            {isVideo ? (
              <Video
                msid={bannerPopup.id}
                autoplay
                slikeId={bannerPopup.slikeId}
                playerType={bannerPopup.playerType}
                videoClassName="popup_video_wrapper"
                allowDim={false}
                source="USNHP_MainVideoWidget"
                updateplayerConfig={updateplayerConfig}
              />
            ) : (
              <ImageV2
                msid={bannerPopup.id}
                resizemode={4}
                imgsize={bannerPopup.imagesize}
                height="620"
                alt={heading}
                placeHolderSrc={
                  imagePlaceHolderSrc || `${IMAGE_URL}123379562.cms`
                }
                onError={onError}
                className={s.popupImg}
              />
            )}
          </div>

          {/* Title */}
          {heading && (
            <div className={s.popupTitle}>
              <h2 dangerouslySetInnerHTML={{ __html: heading }} />
            </div>
          )}

          {/* Caption / synopsis */}
          {synopsis && (
            <div
              className={s.popupSyn}
              dangerouslySetInnerHTML={{ __html: synopsis }}
            />
          )}
        </div>
      </div>
    </PopupOverlay>
  );
};

StoryCardPopup.propTypes = {
  show: PropTypes.bool.isRequired,
  bannerPopup: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    slikeId: PropTypes.string,
    playerType: PropTypes.string,
    imagesize: PropTypes.string,
    hl: PropTypes.string,
    title: PropTypes.string,
    syn: PropTypes.string,
    des: PropTypes.string,
    cap: PropTypes.string,
  }),
  popupRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(Object) }),
  ]),
  onClose: PropTypes.func.isRequired,
  onOverlayClose: PropTypes.func,
  imagePlaceHolderSrc: PropTypes.string,
  updateplayerConfig: PropTypes.objectOf(PropTypes.any),
  white: PropTypes.bool,
  isMobile: PropTypes.bool,
};

StoryCardPopup.defaultProps = {
  bannerPopup: null,
  popupRef: null,
  onOverlayClose: null,
  imagePlaceHolderSrc: '',
  updateplayerConfig: { skipReco: true },
  white: false,
  isMobile: false,
};

export default StoryCardPopup;
